module.exports = __webpack_public_path__ + "static/media/logouthover.96ad1280.svg";